import React, { useEffect, useState } from 'react';
import Page from "../[...all]/index";
import { useSiteQuery } from "../../hooks";
import query from './thankyou.graphql';
import { useRouter } from 'next/router'
import { trackPurchase } from "../../lib/GA";

interface Props {
  showBreadcrumbs?: boolean;
  children?: React.ReactNode;
}

const ThankyouPage = ({ showBreadcrumbs, children }: Props) => {
  const [loaded, setLoaded] = useState(false);
  const router = useRouter();
  const params = router.query;

  const bookeoCategoryIdentifierString = (params['product_code'] as string) ?? null;
  let bookeoCategoryIdentifiers = [] as string[];
  if (bookeoCategoryIdentifierString) {
    bookeoCategoryIdentifiers = bookeoCategoryIdentifierString.split(";");
  }

  const itemDescString = (params['item_desc'] as string) ?? null;
  let itemDescs = [] as string[];
  if (itemDescString) {
    for (let itemDesc of itemDescString.split(";")) {
      itemDescs.push(decodeURI(itemDesc));
    }
  }

  let productCodeItemDescMap = {};
  for (let i = 0; i < bookeoCategoryIdentifiers.length; i++) {
    productCodeItemDescMap[bookeoCategoryIdentifiers[i]] = itemDescs[i];
  }

  const totalPaid = (params['total_paid'] as string) ?? 0;
  const bookingNumber = params['booking_number'] ?? null;

  const [{ data}] = useSiteQuery<ThankyouQuery>({ query, variables: { bookeoCategoryIdentifier: bookeoCategoryIdentifiers } });
  const entries = data?.entries ?? [];

  if (bookeoCategoryIdentifiers && bookeoCategoryIdentifiers.length && bookingNumber) {
    let items = [] as object[];
    for (let bookeoCategoryIdentifier of bookeoCategoryIdentifiers) {
      let itemName = productCodeItemDescMap[bookeoCategoryIdentifier];
      for (let entry of entries) {
        if (entry?.bookeoCategoryIdentifier === bookeoCategoryIdentifier) {
          itemName = entry?.title;
        }
      }
      const item = {
        item_id: bookeoCategoryIdentifier,
        item_name: itemName
      };
      items.push(item);
    }

    useEffect(() => {
      if (!loaded) {
        trackPurchase(window, items, bookingNumber, totalPaid);
        setLoaded(true);
      }
    }, [loaded]);
  }

  return Page({ isSitemapRequest: false, uri: 'courses/thankyou', showBreadcrumbs, children });
};

export default ThankyouPage;
